module.exports = __webpack_public_path__ + "img/icon_close_06.eb78ffc0.svg";